import React from 'react';
import {
  Shield, AlertTriangle, FileText, Clock, MessageSquare,
  TrendingUp, BarChart3, Sparkles
} from 'lucide-react';

export const RISK_COLORS = {
  Low: 'bg-emerald-100 text-emerald-800',
  Medium: 'bg-amber-100 text-amber-800',
  High: 'bg-orange-100 text-orange-800',
  Critical: 'bg-red-100 text-red-800',
};

export const STATUS_COLORS = {
  Planning: 'bg-blue-100 text-blue-800',
  'Field Work': 'bg-indigo-100 text-indigo-800',
  Drafting: 'bg-purple-100 text-purple-800',
  'Under Review': 'bg-amber-100 text-amber-800',
  'Report Finalised': 'bg-emerald-100 text-emerald-800',
  Closed: 'bg-gray-100 text-gray-600',
};

export const OBS_STATUS_COLORS = {
  Draft: 'bg-gray-100 text-gray-700',
  Generated: 'bg-blue-100 text-blue-700',
  'Sent for Review': 'bg-indigo-100 text-indigo-700',
  'Under Review': 'bg-amber-100 text-amber-700',
  Approved: 'bg-emerald-100 text-emerald-700',
  Rejected: 'bg-red-100 text-red-700',
  Finalised: 'bg-teal-100 text-teal-700',
};

export const FOLLOWUP_STATUS_COLORS = {
  Open: 'bg-red-100 text-red-700',
  'In Progress': 'bg-blue-100 text-blue-700',
  'Awaiting Evidence': 'bg-amber-100 text-amber-700',
  Closed: 'bg-emerald-100 text-emerald-700',
  Reopened: 'bg-orange-100 text-orange-700',
};
